import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const LawEnforcement = () => {
  return (
    <div>
      <Navbar />
        <section className="in_page p70 bg4">
              <div className="container"> 
                    <h1 className="hadding">Law Enforcement</h1>
                    <h2 ><b>Cooperation with Authorities</b></h2>
                    <p>Dyntech is committed to supporting lawful investigations and regulatory compliance worldwide. This page outlines our procedures for responding to valid requests for user data and transaction records.</p> 
   

             <h3 className=" mb-3 mt-md-5">Types of Requests</h3>
            <ul className="list ">
                   <li> <b> Subpoenas & Court Orders: </b>  Civil and criminal court directives. </li>  
                  <li> <b> Regulatory Inquiries: </b>  Requests from financial regulators (e.g., SEC, FCA).</li>  
                  <li> <b> Law Enforcement Requests:  </b>  Local and international police or anti-fraud units. </li>  
                </ul>

                 <h3 className=" mb-3 mt-4 mt-md-5">Our Process</h3>
                <ul className="list ">
                  <li> <b> Verification: </b>   Confirm the validity and jurisdiction of the request. </li>  
                  <li> <b>  Review: </b> Legal and compliance teams assess scope and relevance. </li>  
                  <li> <b> Response:  </b>  Provide only the requested data fields, minimizing disclosure. </li>  
                  <li> <b>  Notification: </b>  We notify users unless legally prohibited (e.g., gag order). </li>  
                </ul>
               <h3 className=" mb-3 mt-4 mt-md-5">Data We Can Provide</h3>
                <ul className="list ">
                  <li> <b>  Account Information:  </b> Name, email, contact details. </li>  
                  <li> <b>  Transactional History:</b>   Orders, trades, deposits, withdrawals. </li>  
                  <li> <b>IP & Access Logs:  </b>   Login timestamps and originating IP addresses. </li>  
                </ul>
                 <h3 className=" mb-3 mt-4 mt-md-5">Data We Cannot Provide</h3>
                <ul className="list mb-4">
                  <li> <b> Proprietary Source Code: </b>   Our platform’s internal software. </li>  
                  <li> <b>   Other Users’ Data: </b> Without separate valid requests. </li>   
                </ul>
                <p>Please include all relevant legal documentation and a point of contact for any follow-up.</p>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default LawEnforcement;
